import { FC, ReactNode } from 'react';
import { Modal } from 'antd';
import S from './styles.module.scss';
import CustomModalFooter from './CustomModalFooter';
import CustomModalHeader from './CustomModalHeader';
import { translate } from 'localizations';
import { useAppSelector } from 'hooks/redux';
import { RootState } from 'store/store';

enum ModalWidth {
	small = '400px',
	middle = '560px',
	big = '720px',
}

interface CustomModalProps {
	open: boolean;
	onCancel: () => void;
	onOk: () => void;
	title: string;
	children: ReactNode;
	okText?: string;
	cancelText?: string;
	showFooter?: boolean;
	aboveFooter?: ReactNode; // контент над футером
	footer?: ReactNode; // кастомный футер
	width?: 'small' | 'middle' | 'big';
	destroyOnClose?: boolean;
	isLoading?: boolean;
	isCancelDisabled?: boolean;
	isOkDisabled?: boolean;
}

const widthMapping: { [key: string]: string } = {
	small: '400px',
	middle: '560px',
	big: '720px',
};

export const CustomModal: FC<CustomModalProps> = ({
	open,
	onCancel,
	onOk,
	title,
	children,
	okText,
	cancelText,
	showFooter = true,
	aboveFooter,
	footer,
	isLoading = false,
	width = ModalWidth.middle,
	destroyOnClose = true,
	isCancelDisabled = false,
	isOkDisabled = false,
}) => {
	const { language } = useAppSelector((state: RootState) => state.lang);

	const modalWidth = widthMapping[width] || widthMapping.middle;
	const cancelModalText = translate('cancelButton', language);
	const okModalText = translate('addButton', language);

	return (
		<Modal
			open={open}
			onCancel={onCancel}
			onOk={onOk}
			className={S.modal}
			title={<CustomModalHeader onCancel={onCancel} title={title} />}
			width={modalWidth}
			closable={false}
			centered
			confirmLoading={isLoading}
			destroyOnClose={destroyOnClose}
			footer={
				showFooter &&
				(footer || (
					<CustomModalFooter
						isLoading={isLoading}
						isCancelDisabled={isCancelDisabled}
						isOkDisabled={isOkDisabled}
						onCancel={onCancel}
						onOk={onOk}
						cancelText={cancelText || cancelModalText}
						okText={okText || okModalText}
						aboveFooter={aboveFooter}
					/>
				))
			}
		>
			{children}
		</Modal>
	);
};
